module.exports = __webpack_public_path__ + "static/media/1.631af194.jpg";